import { getOptionLabel, utilityTunnelDepartments } from "common/enums";
import moment from "moment";
import * as Yup from "yup";

const applicantDetailsSchema = Yup.object({
  employeeContractorDetail: Yup.object({
    employeeId: Yup.string().test("isEmployeeIdRequired", "", function () {
      const [
        { value: current },
        { value: { accessDetails: { accessCardHolderType } } = {} } = {},
      ] = this.from || [];
      if (
        getOptionLabel("utilityTunnelConsumerType", accessCardHolderType) ===
          "Employee" &&
        !current.employeeId
      ) {
        return this.createError({
          message: "Employee Id is required",
        });
      }
      return true;
    }),
    departmentId: Yup.string().required(
      "Applied in GIFT CITY Department is required"
    ),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string()
      .email("Please enter valid email")
      .required("Email is required"),
    companyName: Yup.string().test("isCompanyNameRequired", "", function () {
      const [
        { value: current },
        { value: { accessDetails: { accessCardHolderType } } = {} } = {},
      ] = this.from || [];
      if (
        getOptionLabel("utilityTunnelConsumerType", accessCardHolderType) ===
          "Contractor" &&
        !current.companyName
      ) {
        return this.createError({
          message: "Contractor company name is required",
        });
      }
      return true;
    }),

    roleId: Yup.string().test("isRoleRequired", "", function () {
      const [
        { value: current },
        { value: { accessDetails: { accessCardHolderType } } = {} } = {},
      ] = this.from || [];
      const isCapexRequired = !!utilityTunnelDepartments.find(
        ({ value }) => value === current.departmentId
      )?.isCapexOpex;

      if (
        getOptionLabel("utilityTunnelConsumerType", accessCardHolderType) ===
          "Contractor" &&
        isCapexRequired &&
        !current.roleId
      ) {
        return this.createError({
          message: "Applied in GIFT CITY section is required",
        });
      }
      return true;
    }),
    mobileNumber: Yup.string()
      .matches(/^\d{10}$/, "Please enter valid mobile number")
      .required("Mobile number is required"),
    purposeOfVisit: Yup.string(),
  }),
});

const accessDetailsSchema = Yup.object({
  employeeContractorDetail: Yup.object({
    workingHoursFrom: Yup.date()
      .test("isWorkingHoursFromRequired", "", function () {
        const [
          { value: current },
          { value: { accessDetails: { accessCardHolderType } } = {} } = {},
        ] = this.from || [];

        if (
          getOptionLabel("utilityTunnelConsumerType", accessCardHolderType) ===
            "Contractor" &&
          !current.workingHoursFrom
        ) {
          return this.createError({
            message: "Working Hours From is required",
          });
        }
        return true;
      })
      .typeError("Please enter valid date"),
    workingHoursTo: Yup.date()
      .test("workingHoursToValidation", "", function () {
        const [
          { value: current },
          { value: { accessDetails: { accessCardHolderType } } = {} } = {},
        ] = this.from || [];

        const isContractor =
          getOptionLabel("utilityTunnelConsumerType", accessCardHolderType) ===
          "Contractor";

        const from = current?.workingHoursFrom;
        const to = current?.workingHoursTo;

        if (isContractor && !to) {
          return this.createError({
            message: "Working Hours To is required",
          });
        }

        if (!from || !to) return true;

        const fromTime = moment(from);
        const toTime = moment(to);

        if (isContractor && toTime.isSameOrBefore(fromTime)) {
          return this.createError({
            message: "Working hours to must be after working hours from",
          });
        }

        return true;
      })
      .typeError("Please enter valid date"),
  }),
  accessDetails: Yup.object({
    doorId: Yup.number().required("Door is required"),
    locationId: Yup.number().required("Location is required"),
    accessRequiredFrom: Yup.date()
      .required("Access Required From Date is required")
      .min(
        new Date(new Date().setHours(0, 0, 0, 0)),
        "Past date is not allowed"
      ),
    accessRequiredTo: Yup.date()
      .required("Access Required To Date is required")
      .min(
        Yup.ref("accessRequiredFrom"),
        "Access required to date must be after access required from date"
      ),
    expectedReturnDate: Yup.date().min(
      Yup.ref("accessRequiredTo"),
      "expected return date must be after access required to date"
    ),
    isAcknowledgment: Yup.boolean().test(
      "isAcknowledgment",
      "* Please accept the terms and conditions",
      (value) => value === true
    ),
    accessCardHolderType: Yup.number().required("Holder Type is required"),
  }),
  extraValues: Yup.object({
    blockId: Yup.number().required("Block is required"),
  }),
});

export const getAccessDetailSchema = {
  0: applicantDetailsSchema,
  1: accessDetailsSchema,
};
